export enum NumberConstants {
  MAX_CLUSTERS = 15,
}
